document.addEventListener('DOMContentLoaded', function () {
  let timelineSwiper;

  const initTimelineSwiper = () => {
    if (window.innerWidth <= 992) {
      if (!timelineSwiper) {
        timelineSwiper = new Swiper('.timeline-swiper', {
          slidesPerView: "auto",
          spaceBetween: 60,
          grabCursor: true,
          pagination: {
            el: '.timeline-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: ".timeline-next",
            prevEl: ".timeline-prev"
          },
        });
      }
    } else {
      if (timelineSwiper) {
        timelineSwiper.destroy(true, true);
        timelineSwiper = undefined;
      }
    }
  };

  initTimelineSwiper();

  window.addEventListener('resize', initTimelineSwiper);

  gsap.registerPlugin(ScrollTrigger);

  const tmLancamento = gsap.timeline({
    scrollTrigger: {
      trigger: ".section-institucional-tradicao",
      start: "40% center",
      toggleActions: "play none none reverse",
      // markers: true 
    }
  });

  tmLancamento.to(".img-saco-fechado", { opacity: 0, duration: 0.1 });
  tmLancamento.to(".img-saco-aberto", { opacity: 1, duration: 0.1 }, "<");

  tmLancamento.from(".item-voador", {
    duration: 1.2,

    x: function (index, target) {
      const sacoRect = document.querySelector('.wrapper-embalagem').getBoundingClientRect();
      const itemRect = target.getBoundingClientRect();

      const sacoCenterX = sacoRect.left + (sacoRect.width / 2);
      const itemCenterX = itemRect.left + (itemRect.width / 2);

      return sacoCenterX - itemCenterX;
    },

    y: function (index, target) {
      const sacoRect = document.querySelector('.wrapper-embalagem').getBoundingClientRect();
      const itemRect = target.getBoundingClientRect();

      const sacoOriginY = sacoRect.top + (sacoRect.height * 0.7);
      const itemCenterY = itemRect.top + (itemRect.height / 2);

      return sacoOriginY - itemCenterY;
    },

    scale: 0,
    opacity: 0,
    stagger: 0.08,
    ease: "power3.out"
  }, "-=0.1");
});